module.exports = __webpack_public_path__ + "static/media/settings.0960e90d.svg";